import React from 'react'
import PropTypes from 'prop-types'
import * as S from './style'

const SantanderBrand = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 15 16"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.7346 7.36567C10.7166 6.82463 10.5746 6.28358 10.3081 5.79851L7.96209 1.52612C7.78436 1.20896 7.65995 0.854478 7.58886 0.5L7.48223 0.686567C6.89573 1.75 6.89573 3.03731 7.48223 4.10075L9.36611 7.51493C9.95261 8.57836 9.95261 9.86567 9.36611 10.9291L9.25948 11.1157C9.18839 10.7612 9.06398 10.4067 8.88626 10.0896L7.16232 6.95522L6.0782 4.95896C5.90047 4.64179 5.77607 4.28731 5.70498 3.93284L5.59834 4.1194C5.01185 5.16418 5.01185 6.47015 5.59834 7.51493L7.5 10.9291C8.08649 11.9925 8.08649 13.2799 7.5 14.3433L7.39336 14.5299C7.32227 14.1754 7.19787 13.8209 7.02014 13.5037L4.67417 9.23134C4.35427 8.65298 4.21209 8.01866 4.24763 7.38433C1.74171 8.07463 0 9.52985 0 11.2276C0 13.5784 3.359 15.5 7.5 15.5C11.641 15.5 15 13.597 15 11.2276C14.982 9.51119 13.2583 8.05597 10.7346 7.36567"
        fill="#F3123C"
      />
    </svg>
  )
}

const SeeInstallmentTestABCard = ({ link }) => {
  return (
    <S.SeeInstallmentContainer id="valorVerParcelas">
      <S.SeeInstallmentLink
        href={`${link}&lkid=1446&/#VerParcelasCardRB`}
        id="link_card"
        target="_blank"
      >
        Ver parcelas
      </S.SeeInstallmentLink>
    </S.SeeInstallmentContainer>
  )
}

SeeInstallmentTestABCard.propTypes = {
  link: PropTypes.string.isRequired,
}

export default SeeInstallmentTestABCard
